'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var React = require('react');
var React__default = _interopDefault(React);
var svgIcon = require('./svg-icon-501cae97.js');

var Confirmed = function (_a) {
    var dataCy = _a.dataCy, className = _a.className, variant = _a.variant, size = _a.size, svgProps = tslib_es6.__rest(_a, ["dataCy", "className", "variant", "size"]);
    return (React__default.createElement(svgIcon.SvgIcon, tslib_es6.__assign({ width: "34", height: "26", viewBox: "0 0 34 26", xmlns: "http://www.w3.org/2000/svg", className: className, variant: variant, size: size, "data-cy": dataCy }, svgProps),
        React__default.createElement("path", { d: "M29.5859 0.40625L11.0938 18.8984L4.34375 12.0781C3.99219 11.7969 3.42969 11.7969 3.14844 12.0781L1.10938\n        14.1172C0.828125 14.3984 0.828125 14.9609 1.10938 15.3125L10.5312 24.6641C10.8828 25.0156 11.375 25.0156\n        11.7266 24.6641L32.8203 3.57031C33.1016 3.28906 33.1016 2.72656 32.8203 2.375L30.7812 0.40625C30.5\n        0.0546875 29.9375 0.0546875 29.5859 0.40625Z", fill: "currentColor" })));
};

exports.Confirmed = Confirmed;
